export default __webpack_public_path__ + "static/media/mfp-event.072c9a0d.svg";